import constants, { ACCESS_TOKEN, HTTP_METHODS } from '../../../settings/shared/constants'
import axiosClient from '../../common';

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}


function filterInstructionList(pageNumber, pageSize, filterName) {
    return axiosClient({
        url: constants.api.Prompt.filterPrompt + "?page=" + pageNumber + "&size=" + pageSize + "&sort=string",
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: filterName
    });
}

function updateInstructionList(updateData, id) {
    return axiosClient({
        url: constants.api.Prompt.updatePrompt + id,
        method: HTTP_METHODS.PUT,
        headers: _constructHeader(),
        data: updateData
    });
}

function createInstruction(createData) {
    return axiosClient({
        url: constants.api.Prompt.createPrompt,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: createData
    });
}


const PromptService = {
    filterInstructionList, updateInstructionList, createInstruction
}

export default PromptService;